import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reload-buttom',
  templateUrl: './reload-buttom.component.html',
  styleUrls: ['./reload-buttom.component.scss']
})
export class ReloadButtomComponent implements OnInit {

  isDarkEnable = true;
  modalreload=false;
  constructor() { }

  ngOnInit(): void {
    // Check Current Theme
    if (localStorage.getItem('colorMode') === 'dark') {
      document.documentElement.classList.add('dark');
      this.isDarkEnable = true;
    } else if (localStorage.getItem('colorMode') === 'light') {
      document.documentElement.classList.remove('dark');
      this.isDarkEnable = false;
    }
  }
  reloadPage(){
    window.location.reload();
  this.modalreload=false;
  }
}
